import React, { useRef } from 'react';

export default (Component, props) => {
  const ref = useRef(null);

  const addFocusOnClick = () => {
    if (props.onClick) {
      return {
        ...props,
        onClick: () => {
          props.onClick();
          ref.current && ref.current.focus();
        },
      };
    }
    return {
      ...props,
      onClick: () => ref.current && ref.current.focus(),
    };
  };

  return <Component ref={ref} {...addFocusOnClick()} />;
};
